<!-- Only for sandbox mode to preview hidden content -->
<ng-template [ngIf]="sandbox">
  <div class="form-group p-10">
   
      <ion-item>
        <ion-toggle [(ngModel)]="isLoggedIn"></ion-toggle>
        <ion-label>Preview Hidden Content</ion-label>
      </ion-item>
     
  </div>
</ng-template>



<ng-template [ngIf]="isLoggedIn">
  <app-content-control *ngIf="controls" [contentControls]="controls"></app-content-control>  
</ng-template>

<ng-template [ngIf]="!isLoggedIn">
  <div  [froalaView]="noAccessMessage | multiLang"></div>

  <div class="social-login">
    <ng-container *ngFor="let provider of providers">

      <ion-button type="button"  expand="block"  mode="ios" [ngClass]="'button-'+provider" class="m-t-5 m-b-5" (click)=signIn(provider)>
      <ion-icon slot="start" [name]="'logo-'+provider" fill="clear" strong="true"></ion-icon>
     Sign in with {{provider | titlecase}}</ion-button>
  
    </ng-container>
  </div>
  
 
</ng-template>



